
import { useState, useEffect, useCallback } from 'react';
import { TradingViewCrawlerService, type CrawlJob } from '@/services/TradingViewCrawlerService';

export const useCrawlJobRealtime = (jobId: string | null) => {
  const [job, setJob] = useState<CrawlJob | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleJobUpdate = useCallback((updatedJob: CrawlJob) => {
    console.log('🔄 Job update received:', updatedJob);
    setJob(updatedJob);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!jobId) {
      setJob(null);
      setIsLoading(false);
      return;
    }

    // Load initial job data
    const loadJob = async () => {
      setIsLoading(true);
      const jobData = await TradingViewCrawlerService.getCrawlJobById(jobId);
      setJob(jobData);
      setIsLoading(false);
    };

    loadJob();

    // Subscribe to real-time updates
    const subscription = TradingViewCrawlerService.subscribeToJobUpdates(jobId, handleJobUpdate);

    return () => {
      subscription.unsubscribe();
    };
  }, [jobId, handleJobUpdate]);

  return { job, isLoading };
};
